// --------------------------------------------------------------
// Created On: 2026-04-02
// Author: Dimitra Weinstein
//
// Last Modified: 2026-04-27
// Modified By: Dimitra Weinstein
//
// Copyright 2026 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import { CROSS_SUBSIDIARY_PERMISSION } from "../constants/permissions";
import { store } from "src/redux/store";

// Checks if the current user has cross subsidiary access.
export default function userHasCrossSubsidiaryAccess(): boolean {
  const storeState = store.getState();

  if (
    storeState !== undefined &&
    storeState.currentUser !== undefined &&
    storeState.currentUser.permissions !== undefined
  ) {
    const currentUserPermissions = storeState.currentUser.permissions;
    return currentUserPermissions.includes(CROSS_SUBSIDIARY_PERMISSION);
  }

  return false;
}
